import { Field, Formik } from "formik";
import {
  Alert,
  Button,
  Col,
  Form,
  Row,
  Spinner,
  Stack,
  Tab,
  Tabs,
} from "react-bootstrap";
import { Checkbox, Input, Select } from "./Input";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import useParlors from "../hooks/useParlors";
import { useLazyQuery } from "@apollo/client";
import { PARLOR_COUCHES } from "../helpers/query.gql";
import { useMemo, useState } from "react";
import { createStudentCandidate } from "../api/student";
import ChangeCountry from "./ChangeCountry";

export default () => {
  const { t } = useTranslation();
  const { parlors, loading } = useParlors({
    where: {
      core_parlorcouches_aggregate: {
        count: {
          predicate: { _gte: 1 },
          filter: { for_rent: { _eq: true } },
        },
      },
    },
  });

  const [loadCouches, { data: dataCouches, loading: loadingCouches }] =
    useLazyQuery(PARLOR_COUCHES);

  const [tabKey, setTabKey] = useState("base");

  const parlorOptions = useMemo(
    () =>
      parlors.map((parlor) => ({
        value: parlor.id,
        label: parlor.name,
      })),
    [parlors]
  );

  const couchesOptions = useMemo(
    () =>
      dataCouches?.couches.map(
        (el, i) =>
          ({
            value: el.id,
            label: `Chair #${i + 1}`,
          } ?? [])
      ),
    [dataCouches]
  );

  const initialValues = {
    phone_number: "",
    first_name: "",
    last_name: "",
    email: "",
    parlors: null,
    // find_out: null,
    // types: [],
    social_link: "",
    start_date: null,
    end_date: null,
    confirmations: [],
    couch: null,
    // can_show_documents: false,
  };

  const validationSchema = yup.object().shape({
    phone_number: yup
      .string()
      .phone([], t("form_validation.invalid_phone"))
      .required(t("form_validation.required")),
    first_name: yup.string().required(t("form_validation.required")),
    last_name: yup.string().required(t("form_validation.required")),
    email: yup.string().required(t("form_validation.required")),
    social_link: yup.string().required(t("form_validation.required")),
    parlors: yup.string().required(t("form_validation.required")),
    couch: yup.string().required(t("form_validation.required")),
  });

  const handleParlorChange = (e) => {
    const selectedParlor = Number(e.target.value);
    loadCouches({
      variables: {
        where: {
          parlor_id: { _eq: selectedParlor },
          for_rent: { _eq: true },
        },
      },
    });
  };

  const handleOnSubmit = async (form, { setStatus }) => {
    console.log(form);
    const data = { ...form, who_studing: "guest" };
    try {
      await createStudentCandidate(data);
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleOnSubmit}
    >
      {({ handleSubmit, isSubmitting, status }) => (
        <Form onSubmit={handleSubmit}>
          {status === "success" ? (
            <Alert variant="success">Thanks you!</Alert>
          ) : (
            <Tabs
              id="uncontrolled-tab-rent-form"
              activeKey={tabKey}
              className="mb-3"
              onSelect={(k) => setTabKey(k)}
              justify
            >
              <Tab color="danger" eventKey="base" title="Base">
                <Stack gap={3}>
                  <ChangeCountry />

                  <Field
                    name={"phone_number"}
                    label={"Phone number"}
                    type={"text"}
                    component={Input}
                  />
                  <Field
                    name={"first_name"}
                    label={"First name"}
                    type={"text"}
                    component={Input}
                  />
                  <Field
                    name={"last_name"}
                    label={"Last name"}
                    type={"text"}
                    component={Input}
                  />
                  <Field
                    name={"email"}
                    label={"Email"}
                    type={"text"}
                    component={Input}
                  />
                  <Field
                    name={"social_link"}
                    label={"Any social media link"}
                    type={"text"}
                    component={Input}
                  />
                  <Button onClick={() => setTabKey("certificate")}>Next</Button>
                </Stack>
              </Tab>
              <Tab eventKey="certificate" title="Certificate">
                <Stack gap={3}>
                  <Field
                    name={"parlors"}
                    component={Select}
                    label={"Studio"}
                    options={parlorOptions}
                    loading={loading}
                    onChange={handleParlorChange}
                  />
                  <Field
                    name={"couch"}
                    component={Select}
                    label={"Couch"}
                    options={couchesOptions}
                    loading={loadingCouches}
                  />
                  <Stack direction="horizontal" gap={3}>
                    <Field
                      name={"start_date"}
                      label={"Start date"}
                      type={"date"}
                      component={Input}
                    />
                    <Field
                      name={"end_date"}
                      label={"End date"}
                      type={"date"}
                      component={Input}
                    />
                  </Stack>
                  <Field
                    label={"I confirm that"}
                    name={"confirmations"}
                    component={Checkbox}
                    options={[
                      { label: "I have permission to stay in the country", value: "has_country_permission" },
                      { label: "I have a sanitary book", value: "has_san_book" },
                      { label: "I have an identity document (ID)", value: "has_passport" },
                    ]}
                  />

                  <div className="d-grid gap-2">
                    <Button
                      variant="secondary"
                      onClick={() => setTabKey("base")}
                    >
                      Back
                    </Button>

                    <Button disabled={isSubmitting} type="submit">
                      {isSubmitting && <Spinner size="sm" />}{" "}
                      {t("control_buttons.submit")}
                    </Button>
                  </div>
                </Stack>
              </Tab>
            </Tabs>
          )}
          {status === "error" && (
            <Alert variant="danger">Something went wrong...</Alert>
          )}
        </Form>
      )}
    </Formik>
  );
};
